<div class="main-container" *ngIf="!preLoader">
  <div class="sub-container d-flex">
    <div class="background-image" [style.background-image]="brand.id ? 'url(' + brand.loginImagePath + ')' : null">
      <div>
        <div class="welcome-content-overlay">
          <div class="welcome-message">
            {{ 'welcomeTo' | translate }}
          </div>
          <div>
            <img *ngIf="brand.id" [src]="brand.nameLogoPath" class="school-name-image" />
          </div>
          <div class="educational-message">
            {{ brand.loginTagline }}
          </div>
        </div>
        <div class="quote-content-overlay welcome-message">
          <div class="quote" *ngIf="brand.loginQuote">
            <div>"{{ brand.loginQuote }}"</div>
            <div class="quote-author" *ngIf="brand.authorNameDisplay && brand.authorName">{{ brand.authorName }}</div>
          </div>
          <div class="quote" *ngIf="!brand.loginQuote && messages[currentIndex]">
            <div>"{{ messages[currentIndex].quote }}"</div>
            <div class="quote-author">{{ messages[currentIndex].author }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-main-container" *ngIf="!loginWithSchoolURL">
      <div class="help-link-contact">
        <a [ngClass]="{
          'show-help-link': isGoBack,
          'show-and-hide-login-container': !isGoBack
        }" class="show-help-link-go-back" (click)="handleGoBack()">{{'goBack' | translate}}</a>
        <div class="headerbar-right">
          <app-language-dropdown></app-language-dropdown>
          <a class="show-help-link help-link-header" [href]="brand.helpUrl" target="_blank">{{ 'help' | translate
            }}</a>
        </div>
    </div>
      <div [ngClass]="{
          'login-container': !otpVerificationPage,
          'show-and-hide-login-container': otpVerificationPage || isForgotPassword || isResetPassword
        }">
        <div [ngClass]="{
            'login-sub-container': !showPasswordInput,
            'login-sub-container-password': showPasswordInput
          }">
          <div class="text-center login-text">
            <img *ngIf="brand.id" [src]="brand.logoPath" class="login-w-image" />
          </div>
          <div class="text-center" [ngClass]="{
              'login-heading': !showPasswordInput,
              'login-heading-in-password': showPasswordInput 
            }">
            {{ 'login' | translate  }}
          </div>
          <div class="login-message text-center">
            {{ 'loginWithYourCredentials' | translate  }}
          </div>
          <div class="form-group input-login-details email-input-container">
            <label for="email" [ngClass]="{
                'login-label-error': errorMessage.userEmail,
                'login-label': !errorMessage.userEmail
              }">{{ 'usernameOrEmailId' | translate  }}</label>
            <div class="email-input-group">
              <input type="text" class="form-control" id="text" name="userEmail" autocomplete="off" [ngClass]="{
                  'email-input': !errorMessage.userEmail,
                  'email-input-error': errorMessage.userEmail
                }" minlength="2" maxlength="90" [(ngModel)]="userEmail" #emailAddress
                (input)="handleDebounceEmail(emailAddress)" placeholder="{{ 'enterYourUsernameOrEmailId' | translate  }}"
                (keyup.enter)="
                  !showPasswordInput ? submitOtpVerificationPage() : ''
                " />
              <div class="error-message">
                <span *ngIf="errorMessage.userEmail">
                  {{ errorMessage.userEmail }}</span>
              </div>
            </div>
          </div>
          <div class="form-group input-login-details password-visibility" [ngClass]="{
              'password-visibility': showPasswordInput,
              show: showPasswordInput
            }" *ngIf="showPasswordInput">
            <label for="password" class="login-label">{{
              'password' | translate 
              }}</label>
            <div class="password-input-group">
              <input class="form-control email-input" (input)="handleDebouncePassword(passwordInput)"
                [(ngModel)]="password" #passwordInput placeholder="{{ 'enterYourPassword' | translate  }}" id="password"
                name="password" type="password" (keyup.enter)="
                  showPasswordInput ? submitPasswordVerification() : ''
                " />
              <span class="password-icon">
                <img src="../../assets/img/password-icon.svg" alt="Password Icon" />
              </span>
            </div>
            <div class="forgot-password-container" (click)="handleForgotPassword()">
              <span class="forgot-password-link">{{
                'forgotPassword' | translate 
                }}</span>
            </div>
          </div>
          <div class="login-btn text-center">
            <button class="btn btn-otp" type="submit" (click)="
                showPasswordInput
                  ? submitPasswordVerification()
                  : submitOtpVerificationPage()
              " [disabled]="
                loader
              ">
              <ng-container *ngIf="loader; else notLoading">
                <app-button-loader></app-button-loader>
              </ng-container>
              <ng-template #notLoading>
                {{
                showPasswordInput ? ('login' | translate  ): ('getOTP' | translate )
                }}
              </ng-template>
            </button>
          </div>
          <div class="text-center login-url-links" (click)="togglePasswordInput()">
            {{
            showPasswordInput
            ? ('loginWithOTP' | translate )
            : ('loginWithPassword' | translate )
            }}
          </div>
          <div class="text-center or-link">
            {{ 'or' | translate  }}
          </div>
          <div class="text-center login-url-links" (click)="loginWithDomainURL()">
            {{ 'enterYourSchoolURL' | translate  }}
          </div>
          <div class="text-center login-link">
            <span>{{ 'notRegistered' | translate  }} </span><span class="login-url-links" (click)="openRegisterLink()">{{
              'register' | translate 
              }}</span>
          </div>
        </div>
      </div>
      <div [ngClass]="{
          'login-otp-container': otpVerificationPage,
          'show-and-hide-login-container': !otpVerificationPage
        }">
        <div [ngClass]="{
            'login-sub-container': !showPasswordInput,
            'login-sub-container-password': showPasswordInput
          }">
          <div class="text-center login-text">
            <img *ngIf="brand.id" [src]="brand.logoPath" class="login-w-image" />
          </div>
          <div class="text-center" [ngClass]="{
              'login-heading': !showPasswordInput,
              'login-heading-in-password': showPasswordInput
            }">
            {{ 'otpVerification' | translate  }}
          </div>
          <div class="login-message text-center">
            {{ 'otpVerificationMessage' | translate  }}
          </div>
          <div class="input-login-details otp-inputs-container">
            <input id="otp-input-0" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otp[0]"
              (keyup)="moveToNext($event, 0)" (keydown)="handleKeyDown($event)" autocomplete="off" />
            <input id="otp-input-1" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otp[1]"
              (keyup)="moveToNext($event, 1)" (keydown)="handleKeyDown($event)" autocomplete="off" />
            <input id="otp-input-2" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otp[2]"
              (keyup)="moveToNext($event, 2)" (keydown)="handleKeyDown($event)" autocomplete="off" />
            <input id="otp-input-3" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otp[3]"
              (keyup)="moveToNext($event, 3)" (keydown)="handleKeyDown($event)" autocomplete="off" />
          </div>
          <div class="text-center">
            <button class="resend-otp-links" type="submit" [disabled]="loader || otpTime > 0 || countdown === 0"
              (click)="resendOtp()">
              {{ 'resendOtp' | translate  }}</button><span class="otp-timer-text">
              {{ 'in' | translate  }} {{ otpTime }} {{ 'sec' | translate  }} ({{
              countdown
              }}
              {{ 'resendAttempts' | translate  }} )</span>
          </div>
          <div class="login-btn text-center">
            <button class="btn btn-otp" type="submit" [disabled]="loader" (click)="verifyingOtpForGenericLogin()">
              <ng-container *ngIf="loader; else notLoadingLogin">
                <app-button-loader></app-button-loader>
              </ng-container>
              <ng-template #notLoadingLogin>
                {{ 'login' | translate  }}
              </ng-template>
            </button>
          </div>
          <div class="text-center login-url-links" (click)="handleOnclickPassword()">
            {{ 'loginWithPassword' | translate  }}
          </div>
          <div class="text-center login-link">
            <span>{{ 'notRegistered' | translate  }} </span><span class="login-url-links" (click)="openRegisterLink()">{{
              'register' | translate 
              }}</span>
          </div>
        </div>
      </div>
      <div [ngClass]="{
        'login-container': isForgotPassword ,
        'show-and-hide-login-container': !isForgotPassword
      }"> 
          <div [ngClass]="{
            'login-sub-container': isForgotPassword,
            'login-sub-container-password': isForgotPassword 
          }">
          <div class="text-center login-text">
            <img *ngIf="brand.id" [src]="brand.logoPath" class="login-w-image" />
          </div>
            <div class="text-center login-heading ">
              {{
                'ForgotPassword' | translate 
                }}
            </div>
            <div class="login-message text-center">
              {{
                'createNewPassword' | translate 
                }}
            </div>
            <div class="form-group input-login-details email-input-container login-sub-container-password">
              <label for="url" [ngClass]="{
                'login-label-error': errorMessage.userEmail,
                'login-label': !errorMessage.userEmail
              }">{{'usernameOrEmailId' | translate  }}</label>
              <div class="domain-url-input-group">
                <input type="text" class="form-control" id="text" name="userEmail" [ngClass]="{
                  'email-input': !errorMessage.userEmail,
                  'email-input-error': errorMessage.userEmail
                }" minlength="2" maxlength="90" [(ngModel)]="userEmail" #emailAddress
                  placeholder="{{ 'enterYourUsernameOrEmailId' | translate  }}" (input)="handleDebounceEmail(emailAddress)"
                  (keyup.enter)="isForgotPassword ? sendOptForForgotPassword(false): ''" />
                <div class="error-message">
                  <span *ngIf="errorMessage.userEmail">
                    {{ errorMessage.userEmail }}</span>
                </div>
              </div>
            </div>
            <div class="login-btn text-center">
              <button class="btn btn-otp" type="submit" [disabled]="
            loader
         " (click)="sendOptForForgotPassword(false) ">
                <ng-container *ngIf="loader; else notLoadingBtn"><app-button-loader></app-button-loader></ng-container>
                <ng-template #notLoadingBtn>
                  {{
                    'sendOtp' | translate 
                    }}
                </ng-template>
              </button>
            </div>
          </div>
        </div>
           <!-- Verify & Reset Password -->
      <div [ngClass]="{
        'login-container': isResetPassword ,
        'show-and-hide-login-container': !isResetPassword
      }"> 
          <div [ngClass]="{
            'login-sub-container': isResetPassword,
            'login-sub-container-password': isResetPassword 
          }">
          <div class="text-center login-text">
            <img *ngIf="brand.id" [src]="brand.logoPath" class="login-w-image" />
          </div>
            <div class="text-center login-heading ">
              {{
                'resetPassword' | translate 
                }}
            </div>
            <div class="login-message text-center">
              {{
                'verifyOtpAndSetNewPassword' | translate 
                }}
            </div>
            <div class="input-login-details otp-inputs-container">
              <input id="send-otp-input-0" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otpForForgotPassword[0]"
                (keyup)="moveToNextForForgotPasswordOTP($event, 0)" (keydown)="handleKeyDown($event)" autocomplete="off" />
              <input id="send-otp-input-1" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otpForForgotPassword[1]"
                (keyup)="moveToNextForForgotPasswordOTP($event, 1)" (keydown)="handleKeyDown($event)" autocomplete="off" />
              <input id="send-otp-input-2" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otpForForgotPassword[2]"
                (keyup)="moveToNextForForgotPasswordOTP($event, 2)" (keydown)="handleKeyDown($event)" autocomplete="off" />
              <input id="send-otp-input-3" type="text" maxlength="1" class="login-otp-input" [(ngModel)]="otpForForgotPassword[3]"
                (keyup)="moveToNextForForgotPasswordOTP($event, 3)" (keydown)="handleKeyDown($event)" autocomplete="off" 
                (keyup.enter)="resetPassword()"
                />
            </div>
            <div class="text-center">
              <button class="resend-otp-links" type="submit" [disabled]="loader || otpTime > 0 || countdown === 0"
                (click)="sendOptForForgotPassword(true)">
                {{ 'resendOtp' | translate  }}</button><span class="otp-timer-text">
                {{ 'in' | translate  }} {{ otpTime }} {{ 'sec' | translate  }} ({{
                countdown
                }}
                {{ 'resendAttempts' | translate  }} )</span>
            </div>
            <div class="form-group input-login-details password-visibility login-sub-container-password" [ngClass]="{
            }" *ngIf="isResetPassword">
            <label for="password" class="login-label">{{
              'newPassword' | translate 
              }}</label>
            <div class="password-input-group">
              <input class="form-control email-input" (input)="handleDebouncePassword(passwordInput)"
                [(ngModel)]="password" #passwordInput placeholder="{{ 'enterNewPassword' | translate  }}" id="password"
                name="password" type="password" (keyup.enter)="
                isResetPassword ? resetPassword() : ''
              " />
              <span class="password-icon">
                <img src="../../assets/img/password-icon.svg" alt="Password Icon" />
              </span>
            </div>
            <div class="form-group input-login-details password-visibility" [ngClass]="{
              'password-visibility': isResetPassword,
              show: isResetPassword
            }" *ngIf="isResetPassword">
            <label for="password" class="login-label">{{
              'confirmPassword' | translate 
              }}</label>
            <div class="password-input-group">
              <input class="form-control email-input" (input)="handleDebounceConfirmPassword(confirmNewPasswordInput)"
                [(ngModel)]="confirmNewPassword" #confirmNewPasswordInput placeholder="{{ 'enterConfirmPassword' | translate  }}" id="password"
                name="password" type="password" (keyup.enter)="
                isResetPassword ? resetPassword() : ''
              " />
              <span class="password-icon">
                <img src="../../assets/img/password-icon.svg" alt="Password Icon" />
              </span>
            </div>
          </div>
            <div class="login-btn text-center">
              <button class="btn btn-otp" type="submit" [disabled]="
            loader
         " (click)="resetPassword() ">
                <ng-container *ngIf="loader; else notLoader"><app-button-loader></app-button-loader></ng-container>
                <ng-template #notLoader>
                  {{
                    'submit' | translate 
                    }}
                </ng-template>
              </button>
            </div>
          </div>
        </div>
    </div>
    </div>
    <app-new-login-with-domain *ngIf="loginWithSchoolURL"
      (loginWithEmailIdClicked)="onLoginWithEmailIdClicked()"></app-new-login-with-domain>
  </div>
</div>
<div style="
    background: white;
    width: 100%;
    text-align: center;
    height: 100%;
    position: fixed;
    padding-top: 35vh;
  " *ngIf="preLoader">
  <img *ngIf="brand.id" id="animatedLoader" alt="logo" class="animated infinite pulse" [src]="brand.logoPath"
    style="width: 125px" />
</div>